// #region Imports

import * as React from 'react';
import * as ReactDOM from 'react-dom';

import AiComponent, { aiServiceBaseUrl } from '../components/aiComponent';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { apiCall } from '../components/aiservice/aiservice';
import { ChatProvider } from '../components/aiservice/aiContext';

// #endregion Imports

export function initialize() {
    checkHasAiAccess();
}

// check if user has access
function checkHasAiAccess(){
    apiCall(aiServiceBaseUrl + "/hasaccess")
        .then((data: boolean) => {
        if (!!data) {
            renderAIComponents();
        }
    })
    .catch(error => {
        console.error(error);
    });
}

function renderAIComponents() {
    const container = document.getElementById('faronline-ai');
    !!container && ReactDOM.render(<div className="aiContent">
        <ChatProvider>
            <DndProvider backend={HTML5Backend}>
                <AiComponent />
            </DndProvider>
        </ChatProvider>
    </div>, container);
}
